import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';

@Component({
  selector: 'app-qrcode',
  templateUrl: './qrcode.component.html',
  styleUrls: ['./qrcode.component.scss']
})
export class QrcodeComponent extends ComponentBase implements OnInit {

  constructor() { super() }

  ngOnInit() {
  }

  getValue(): string {
    if(this.attribute.value && this.attribute.value != "") {
      return this.attribute.value
    }

    return this.attribute.key
  }
}
